import { createFileRoute } from '@tanstack/react-router'
import CeleryManager from '@/pages/Celery/CeleryManager'
import { RequirePermission } from '@/components/ui/require-permission'

export const Route = createFileRoute('/_authenticated/celery')({
  component: () => (
    <RequirePermission permission='celery.read'>
      <CeleryManager />
    </RequirePermission>
  ),
})
